import { Alert } from "@nabble/ui";
import type { MfaMethod } from "./mfaMethods";
import { PasskeyVerifyPanel } from "./PasskeyVerifyPanel";
import { RecoveryCodeForm } from "./RecoveryCodeForm";
import { TotpCodeForm } from "./TotpCodeForm";
import type { MfaVerification } from "./useMfaVerification";

interface MfaMethodFormProps {
  method: MfaMethod | null;
  verification: MfaVerification;
  /** Why the methods couldn't be loaded, shown when there is no method to use. */
  loadError: string | null;
}

/** The form of the selected second factor. */
export function MfaMethodForm({ method, verification: v, loadError }: MfaMethodFormProps): React.JSX.Element | null {
  if (method === "totp") return <TotpCodeForm totp={v.totp} loading={v.loading} error={v.error} onVerify={(code) => void v.verifyTotp(code)} />;
  if (method === "passkey") return <PasskeyVerifyPanel loading={v.loading} error={v.error} onVerify={() => void v.verifyPasskey()} />;
  if (method === "recovery-code") {
    return (
      <RecoveryCodeForm value={v.recovery} onChange={v.setRecovery} loading={v.loading} error={v.error} onVerify={() => void v.verifyRecovery()} />
    );
  }
  return loadError ? <Alert tone="danger">{loadError}</Alert> : null;
}
